import { render } from "./slide21_1.vue?vue&type=template&id=043c7516&scoped=true"
import script from "./slide21_1.vue?vue&type=script&lang=js"
export * from "./slide21_1.vue?vue&type=script&lang=js"

import "./slide21_1.vue?vue&type=style&index=0&id=043c7516&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043c7516"]])

export default __exports__